import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { User } from '@talos/kyoko';

export function createUserInfoSlice(user: User) {
  return createSlice({
    name: 'userInfo',
    initialState: {
      user,
    },
    reducers: {
      setUser: (state, action: PayloadAction<User>) => {
        state.user = action.payload;
      },
    },
  });
}
